import { Box, styled, Typography } from '@mui/material';
import FlexBox from 'components/shared/FlexBox';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatPrice } from '../../../utils/numberFormatter';

const PriceWrapper = styled(Box)(({ theme }) => ({
    display: 'flex',
    gap: '5px',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        gap: '0',
    },
}));

export const CollectionProductPrice: React.FC<{
    price: number;
    alignItems?: 'left' | 'right';
}> = (props) => {
    const { price, alignItems = 'right' } = props;
    const { t } = useTranslation('product');

    return (
        <FlexBox textAlign={alignItems} flexDirection="column">
            <PriceWrapper>
                <Typography sx={{ fontWeight: 'bold', lineBreak: 'anywhere' }}>
                    {t('PRODUCT.NET')}
                </Typography>
                <Typography
                    sx={{
                        fontWeight: 'bold',
                        color: '#007cb0',
                        lineBreak: 'anywhere',
                    }}
                >
                    {formatPrice(price)}
                    {' Ft'}
                </Typography>
            </PriceWrapper>

            <PriceWrapper>
                <Typography sx={{ fontWeight: 'bold', lineBreak: 'anywhere' }}>
                    {t('PRODUCT.GROSS')}
                </Typography>
                <Typography
                    sx={{
                        fontWeight: 'bold',
                        color: '#007cb0',
                        lineBreak: 'anywhere',
                    }}
                >
                    {formatPrice(price * 1.27)}
                    {' Ft'}
                </Typography>
            </PriceWrapper>
        </FlexBox>
    );
};
